import inputDetection from './input-detection';

inputDetection.activate();
